// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23YGt","col":"styles_col__3GSAw","actions":"styles_actions__3LB7R","conflict":"styles_conflict__yOUM5"};